import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import { joinStrings } from "../../../utils/misc";
import { Button, Text } from "@pushpress/shared-components";
import styles from "./GoogleCalendarPanel.module.scss";
import { useCalendarSync } from "../../CalendarSync/CalendarSyncProvider/CalendarSyncProvider";
import ConnectedPanel from "../../CalendarSync/CalendarSyncStart/ConnectedPanel";
import { GetCalendars } from "../../../apis/googleSyncApi";

interface GoogleCalendarPanelProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  userUuid: string;
  isConnected: boolean;
  firstName: string;
  calendarData?: GetCalendars;
  onSuccess: VoidFunction;
  onEditClick: VoidFunction;
}

const GoogleCalendarPanel = (props: GoogleCalendarPanelProps) => {
  const {
    className,
    userUuid,
    isConnected,
    firstName,
    calendarData,
    onSuccess,
    onEditClick,
    ...other
  } = props;

  const { connectGoogleAccount } = useCalendarSync();

  const handleConnect = () => {
    connectGoogleAccount(userUuid);
  };

  const confirmDisconnectMessage = `Disconnecting will also remove the sync that automatically adds ${firstName}'s classes and appointments to their Google Calendar.`;

  if (isConnected) {
    return (
      <ConnectedPanel
        className={className}
        userUuid={userUuid}
        firstName={firstName}
        hideReSyncSection
        calendarData={calendarData}
        confirmDisconnectMessage={confirmDisconnectMessage}
        onSuccess={onSuccess}
        onEditClick={onEditClick}
      />
    );
  }

  return (
    <div {...other} className={joinStrings(styles.root, className)}>
      <Text variant="heading-5" color="wolf-800">
        Block specifics days and times
      </Text>
      <Text variant="body-lg" color="wolf-600" className="mt-3">
        Once connected, {firstName} won&apos;t be available at any time there is
        an event on their Google Calendar.
      </Text>
      <Button
        buttonType="primary"
        text="Connect a Google Calendar"
        fullWidth
        className="mt-3"
        size="large"
        type="button"
        onClick={handleConnect}
      />
    </div>
  );
};

export default GoogleCalendarPanel;
